import config from "./config";
// import {get} from "lodash";
import widgetProps from "../helpers/widgetProps";

const get = (value, path, defaultValue) =>
    String(path)
    .split('.')
    .reduce((acc, v) => {
        try {
            return acc[v] === undefined ? defaultValue : acc[v];
        } catch (e) {
            return defaultValue;
        }
    }, value);

const themeValue = function (key, forceDefault = null) {
    const theme = currentTheme();
    let value = get(config, `${key}.${theme}`);

    // Trying to get 'all' config value.
    if (theme !== 'default') {
        if (typeof value === typeof undefined || value === null) {
            value = get(config, `${key}.all`);
        }
    }

    if (typeof value === typeof undefined || value === null) {
        if (forceDefault !== null) {
            value = forceDefault;
        } else {
            value = get(config, `${key}.default`);
        }
    }
    if (typeof value === typeof undefined || value === null) {
        value = null;
        console.warn('Warning: themeValue value not found.', key);
    }

    return value;
};

export function createValue(defaultValue, values = {}) {
    values.default = defaultValue;

    return values;
}

export function currentTheme () {

    const site =  widgetProps()?.site;
    if (typeof site === typeof undefined || site === null) {
        return 'default';
    }

    return site;
}

export default themeValue;
